import { render, staticRenderFns } from "./TransactionLink.vue?vue&type=template&id=c3a3bd56&"
import script from "./TransactionLink.vue?vue&type=script&lang=js&"
export * from "./TransactionLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports